import { IMultiStateSwitch } from './types';
import { OperatorPanelWrapper, OperatorPanelWrapperFullSize } from '../../components/Layout';
import { ButtonsPanel } from './ButtonsPanel';

export const OperatorPanel = (props: IMultiStateSwitch) => {

  return (
    <OperatorPanelWrapperFullSize
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={<>        </>}
      operationModeContent={
        <ButtonsPanel {...props}></ButtonsPanel>
      }
    />
  );
};
